export var CAPTCHA_LENGTH = 5;